import { createContext, useLayoutEffect, useRef, useState } from "react"
import "./LogDisplay.css";

export const LogContext = createContext();

export const LogDisplay = ({children}) => {
    const [text, setText] = useState("");
    const ref = useRef();

    function log(msg) {
        setText((oldText) => {
            ref.current.scrollTo(1000000, 1000000);
            return oldText + msg + "\n";
        });
    }

    return(
        <LogContext.Provider value={{log}}>
            <div ref={ref} className="log_display">
                {text}
            </div>

            {children}
        </LogContext.Provider>
    )
}
